import { ReactNode, Suspense } from 'react';
import styles from './pagina-diferida.module.scss';

/**
 * Lo que se ve mientras baja el chunk de una pagina.
 *
 * ## Por que reusa el cargador del arranque en vez de pintar un `Spin`
 *
 * Hasta el 2026-09-28 esto era un `<Spin>` de antd con `tip`. Se veia **mal y ajeno**: el anillo del
 * arranque mide 67px con borde de 3px y esta centrado en la pantalla entera; el punto de antd sale a
 * unos 20px y, dentro de un contenedor de `40vh`, se quedaba a la altura del primer tercio. Dos
 * cargadores distintos para lo mismo, y el de las navegaciones era el feo.
 *
 * El problema no era antd: es que este velo **nacio en la fase 3**, con el troceado en chunks, cuando
 * las navegaciones dejaron de ser sincronas, y nadie lo puso al lado del que ya existia.
 *
 * Ahora es el MISMO objeto. `index.html` enlaza `public/spinner.css` en el `<head>`, asi que esas
 * clases estan disponibles para todo el arbol: se reusan tal cual en vez de copiar sus valores, que
 * es lo que haria que los dos volvieran a separarse al primer retoque.
 *
 * ## Accesibilidad
 *
 * Lleva `role="status"` porque es una region viva que antes no existia: con un solo bundle las
 * navegaciones eran sincronas, y ahora el contenido desaparece, pasa un rato y vuelve. El texto va
 * dentro para que un lector de pantalla tenga algo que anunciar; el marcado del arranque no lo lleva
 * porque alli no hay nada que anunciar todavia.
 *
 * El texto NO se traduce, y es deliberado: es el nombre de la marca, igual que en el arranque.
 */
const VeloDeCarga = () => (
  <div className={styles.velo} role="status">
    <div className="lds-ring-container">
      <div className="loadingio-spinner-rolling-uchcdsz0gbi">
        <div className="ldio-p2a7ryy310m">
          <div />
        </div>
      </div>
      <div className="lds-ring-text">jobs2live</div>
    </div>
  </div>
);

/**
 * Envuelve el `element` de una ruta en su propia frontera de `Suspense`, que es lo que permite que la
 * pagina llegue en un chunk aparte.
 *
 * Una frontera POR PAGINA y no una sola global: colgada arriba del arbol, cualquier navegacion
 * desmontaria la pantalla entera mientras baja el chunk y el usuario veria el velo de carga a pantalla
 * completa en cada clic, incluso al moverse entre dos pestanas del mismo layout. Aqui solo se suspende
 * el trozo que falta por descargar; el layout que lo contiene se queda donde esta, visible y clicable
 * -- ver `pagina-diferida.module.scss` para por que el velo no es el global.
 */
export const diferida = (pagina: ReactNode) => <Suspense fallback={<VeloDeCarga />}>{pagina}</Suspense>;
